 <div class="example-large-box mat-elevation-z4" style="width:310px;" align="right">
  <!-- <pdf-viewer [src]="formData.manual" [original-size]="false" [zoom]="zoom"
  [render-text]='true' scrolling="auto" [show-all]="true"
  style="display: block; height: 400px;" [fit-to-page]="true">
</pdf-viewer> -->
  <a mat-mini-fab href="{{formData.manual}}" target="_blank" class="my-fab">
      <mat-icon>zoom_in</mat-icon>
  </a>
</div>